export type CorrelationWidgetKind =
  | "corr-controls"
  | "corr-heatmap"
  | "corr-pair-grid"
  | "corr-rolling";

export const CORRELATION_WIDGET_KINDS: CorrelationWidgetKind[] = [
  "corr-controls",
  "corr-heatmap",
  "corr-pair-grid",
  "corr-rolling",
];

export function isCorrelationWidgetKind(kind: string): kind is CorrelationWidgetKind {
  return kind.startsWith("corr-");
}

export function layoutHasCorrelationWidgets(
  widgets: { kind: string }[],
): boolean {
  return widgets.some((w) => isCorrelationWidgetKind(w.kind));
}
